<template>
  <div id="unauthorized">
    <div class="container-fluid">
      <div class="row">
        <div
          role="main"
          class="col d-block pt-2"
        >
          <section class="pt-3">
            <div class="section-title">
              Unauthorised, you don't have permissions to perform this action.
            </div>
          </section>
          <div class="clearfix" />
        </div>
        <div class="clearfix" />
      </div>
    </div>
  </div>
</template>
<script>

export default {

};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/unauthorized/index.vue